import {path} from 'ramda';

export const getIsLoading=path(['defaultSettings','isLoading'])